<template>
  <div class="gang-sheet-builder-sizes">
    <span class="gang-sheet-builder-sizes__title">
      Select size (all sizes are 22 inches wide)
    </span>
    <div class="gang-sheet-builder-sizes__tiles">
      <div v-for="size in sizes" :key="size.value" class="gang-sheet-builder-sizes__tile">
        <Tile
          :key="size.value"
          :value="size"
          :is-selected="gangSheetBuilderSettings.height === size.value"
          @tile-selected="handleTileSelected"
        />
        <div class="gang-sheet-builder-sizes__price">
          <div class="gang-sheet-builder-sizes__price-value">
            {{ n(size.price, "currency") }}
          </div>
          <div v-if="size.discount > 0" class="gang-sheet-builder-sizes__price-discount">
            {{ size.discount }}% off
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { n } from "components/jiffy/vue-cart/helpers/currency";
import Tile from "./Tile.vue";
import { useDtfStore } from "../store";

export default {
  name: "Sizes",
  components: {
    Tile
  },
  setup() {
    return { n };
  },
  computed: {
    ...mapState(useDtfStore, [
      "gangSheetBuilderSettings",
      "gangSheetBuilderSizes",
      "gangSheetBulkPrice"
    ]),
    sizes() {
      const bulkPrices =
        this.gangSheetBulkPrice[this.gangSheetBuilderSettings.variantId]?.bulk_price;
      const sizes = [];

      this.gangSheetBuilderSizes.forEach(size => {
        const sizeHeightFeet = Math.ceil(size.height / 12.0);
        const bulkPrice = bulkPrices?.find(price => price.height === size.height);

        sizes.push({
          label: `${sizeHeightFeet} Feet`,
          value: size.height,
          price: bulkPrice ? (bulkPrice.size_price * sizeHeightFeet).toFixed(2) : null,
          discount: bulkPrice?.percent_off
        });
      });

      return sizes;
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["updateGangSheetBuilderSettings"]),
    ...mapActions(useDtfStore, ["fetchBulkPrice"]),
    handleTileSelected(value) {
      this.updateGangSheetBuilderSettings({ height: value });
    },
    fetchPrice() {
      this.fetchBulkPrice();
    }
  },
  mounted() {
    this.fetchPrice();
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.gang-sheet-builder-sizes {
  margin-bottom: 24px;

  &__title {
    font-size: 17px;
    font-weight: 700;
  }

  &__tiles {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
  }

  &__tile {
    flex-basis: 31%;

    @include with-tablet {
      flex-basis: unset;
    }
  }

  &__price-value {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    padding-top: 6px;
  }

  &__price-discount {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $red-ruby;
    font-size: 13px;
  }

  &__price {
    height: 40px;
  }
}
</style>
